import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Form } from '../../components';

export default class FormField extends React.PureComponent {
  static defaultProps = {
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.string
  };

  static defaultProps = {
    onChange: _.identity,
    name: '',
    value: ''
  };

  onChange = e => {
    const { onChange, name } = this.props;

    e.preventDefault();

    onChange({ name, value: e.target.value });
  };

  render() {
    const { onChange, children, name, ...props } = this.props;

    return (
      <Form.Field onChange={this.onChange} {...props}>
        {children}
      </Form.Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Login/FormField.js